// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("@rails/activestorage").start();
require("channels");

function shouldShowPushPrompt() {
  if (!("Notification" in window)) {
    return false;
  }
  if (!("serviceWorker" in navigator)) {
    return false;
  }
  return Notification.permission !== "denied";
}

function isStandaloneMode() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}

function getVapidPublicKey() {
  const meta = document.querySelector("meta[name='vapid-public-key']");
  if (!meta) {
    return null;
  }
  return meta.getAttribute("content");
}

function getCsrfToken() {
  const meta = document.querySelector("meta[name='csrf-token']");
  if (!meta) {
    return null;
  }
  return meta.getAttribute("content");
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

async function saveSubscription(subscription) {
  const csrfToken = getCsrfToken();
  if (!csrfToken) {
    throw new Error("CSRF token is missing.");
  }
  return fetch("/push_subscriptions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken,
    },
    body: JSON.stringify(subscription),
  });
}

async function openPushPermissionModal() {
  if (!shouldShowPushPrompt()) {
    return;
  }
  const modal = document.querySelector(".push-permission-popup-background");
  if (!modal) {
    return;
  }
  try {
    const registration = await navigator.serviceWorker.getRegistration();
    if (registration) {
      const subscription = await registration.pushManager.getSubscription();
      if (subscription) {
        return;
      }
    }
  } catch (error) {
    console.warn("Failed to check push subscription.", error);
  }
  modal.style.display = "flex";
}

function closePushPermissionModal() {
  const modal = document.querySelector(".push-permission-popup-background");
  if (!modal) {
    return;
  }
  modal.style.display = "none";
}

function hidePushPermissionBanner() {
  const banner = document.querySelector(".js-push-permission-banner");
  if (banner) {
    banner.style.display = "none";
  }
}

async function cleanupPushSubscription() {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  try {
    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration) {
      return;
    }
    const subscription = await registration.pushManager.getSubscription();
    if (!subscription) {
      return;
    }

    const csrfToken = getCsrfToken();
    if (csrfToken) {
      try {
        await fetch("/push_subscriptions", {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken,
          },
          body: JSON.stringify({ endpoint: subscription.endpoint }),
        });
      } catch (error) {
        console.warn("Failed to delete push subscription.", error);
      }
    }

    try {
      await subscription.unsubscribe();
    } catch (error) {
      console.warn("Failed to unsubscribe push subscription.", error);
    }
  } catch (error) {
    console.warn("Push subscription cleanup failed.", error);
  }
}

function submitLogoutForm(action) {
  const form = document.createElement("form");
  form.method = "post";
  form.action = action;

  const csrfToken = getCsrfToken();
  if (csrfToken) {
    const csrfInput = document.createElement("input");
    csrfInput.type = "hidden";
    csrfInput.name = "authenticity_token";
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);
  }

  const methodInput = document.createElement("input");
  methodInput.type = "hidden";
  methodInput.name = "_method";
  methodInput.value = "delete";
  form.appendChild(methodInput);

  document.body.appendChild(form);
  form.submit();
}

async function requestPushPermission() {
  if (!shouldShowPushPrompt()) {
    closePushPermissionModal();
    return;
  }
  try {
    const vapidPublicKey = getVapidPublicKey();
    if (!vapidPublicKey) {
      console.warn("VAPID public key is missing.");
      closePushPermissionModal();
      return;
    }
    let permission = Notification.permission;
    if (permission === "default") {
      permission = await Notification.requestPermission();
    }
    if (permission === "granted") {
      const registration = await navigator.serviceWorker.ready;
      const existing = await registration.pushManager.getSubscription();
      const subscription = existing || await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidPublicKey),
      });
      const response = await saveSubscription(subscription.toJSON());
      if (!response.ok) {
        if (response.status === 409) {
          window.alert("この端末の通知は別のユーザーに紐づいています。通知を使うには以前のユーザーでログアウトしてください。");
        } else {
          window.alert("通知の登録に失敗しました。時間をおいて再度お試しください。");
        }
        closePushPermissionModal();
        return;
      }
      hidePushPermissionBanner();
    }
  } catch (error) {
    console.error(error);
  }
  closePushPermissionModal();
}

window.SundePushPermission = {
  open: openPushPermissionModal,
  close: closePushPermissionModal,
  request: requestPushPermission,
};

window.addEventListener("DOMContentLoaded", () => {
  const searchSheet = document.querySelector("[data-app-search-sheet]");
  const searchSheetInput = searchSheet ? searchSheet.querySelector("[data-app-search-sheet-input]") : null;
  const bottomTabsActiveClass = "login-bottom-tabs__item--active";
  let pendingBottomTabsMenuTimer = null;
  const syncSearchBottomTabsState = (isOpen) => {
    document.querySelectorAll("[data-app-bottom-tabs]").forEach((tabs) => {
      const searchButton = tabs.querySelector("[data-app-bottom-tabs-search]");
      tabs.querySelectorAll(".login-bottom-tabs__item").forEach((item) => {
        if (!item.dataset.appBottomTabsInitialActiveReady) {
          item.dataset.appBottomTabsInitialActive = item.classList.contains(bottomTabsActiveClass) ? "true" : "false";
          item.dataset.appBottomTabsInitialAriaCurrent = item.getAttribute("aria-current") || "";
          item.dataset.appBottomTabsInitialActiveReady = "true";
        }

        if (isOpen) {
          item.classList.remove(bottomTabsActiveClass);
          item.removeAttribute("aria-current");
          return;
        }

        item.classList.toggle(bottomTabsActiveClass, item.dataset.appBottomTabsInitialActive === "true");
        if (item.dataset.appBottomTabsInitialAriaCurrent) {
          item.setAttribute("aria-current", item.dataset.appBottomTabsInitialAriaCurrent);
        } else {
          item.removeAttribute("aria-current");
        }
      });

      if (isOpen && searchButton) {
        searchButton.classList.add(bottomTabsActiveClass);
        searchButton.setAttribute("aria-current", "page");
      }
    });
  };
  const clearPendingBottomTabsMenu = () => {
    if (!pendingBottomTabsMenuTimer) {
      return;
    }
    window.clearTimeout(pendingBottomTabsMenuTimer);
    pendingBottomTabsMenuTimer = null;
  };
  const closeAppHeaderMenus = () => {
    clearPendingBottomTabsMenu();
    document.querySelectorAll("[data-app-header-menu-toggle]").forEach((button) => {
      button.setAttribute("aria-expanded", "false");
    });
    document.querySelectorAll("[data-app-header-menu]").forEach((menu) => {
      menu.hidden = true;
    });
    document.body.classList.remove("login-menu-open");
  };
  const openSearchSheet = () => {
    if (!searchSheet) {
      return;
    }
    closeAppHeaderMenus();
    searchSheet.hidden = false;
    document.body.classList.add("app-search-sheet-open");
    syncSearchBottomTabsState(true);
    window.setTimeout(() => {
      if (searchSheetInput) {
        searchSheetInput.focus();
      }
    }, 50);
  };
  const closeSearchSheet = () => {
    if (!searchSheet) {
      return;
    }
    searchSheet.hidden = true;
    document.body.classList.remove("app-search-sheet-open");
    syncSearchBottomTabsState(false);
  };

  document.querySelectorAll("[data-app-header]").forEach((header) => {
    const searchToggle = header.querySelector("[data-app-header-search-toggle]");
    const searchForm = header.querySelector("[data-app-header-search-form]");
    const syncBottomTabsState = () => {
      const hasOpenMenu = Array.from(header.querySelectorAll("[data-app-header-menu-toggle]")).some((button) => {
        return button.getAttribute("aria-expanded") === "true";
      });
      document.body.classList.toggle("login-menu-open", hasOpenMenu);
    };

    if (searchToggle && searchForm) {
      searchToggle.addEventListener("click", () => {
        const isOpen = searchToggle.getAttribute("aria-expanded") === "true";
        searchToggle.setAttribute("aria-expanded", String(!isOpen));
        searchForm.classList.toggle("is-open", !isOpen);
      });
    }

    const closeAllMenus = () => {
      header.querySelectorAll("[data-app-header-menu-toggle]").forEach((button) => {
        button.setAttribute("aria-expanded", "false");
      });
      header.querySelectorAll("[data-app-header-menu]").forEach((menu) => {
        menu.hidden = true;
      });
      syncBottomTabsState();
    };

    header.querySelectorAll("[data-app-header-menu-toggle]").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.stopPropagation();
        const menuKey = button.getAttribute("data-app-header-menu-toggle");
        const menu = header.querySelector(`[data-app-header-menu='${menuKey}']`);
        const isOpen = button.getAttribute("aria-expanded") === "true";

        closeAllMenus();
        if (menu && !isOpen) {
          button.setAttribute("aria-expanded", "true");
          menu.hidden = false;
          syncBottomTabsState();
        }
      });
    });

    header.querySelectorAll("[data-app-header-menu-close]").forEach((button) => {
      button.addEventListener("click", () => {
        closeAllMenus();
      });
    });

    document.addEventListener("click", (event) => {
      if (!header.contains(event.target)) {
        closeAllMenus();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape") {
        closeAllMenus();
        closeSearchSheet();
      }
    });

    syncBottomTabsState();
  });

  document.querySelectorAll("[data-app-bottom-tabs]").forEach((tabs) => {
    const searchButton = tabs.querySelector("[data-app-bottom-tabs-search]");
    if (searchButton) {
      searchButton.addEventListener("click", () => {
        openSearchSheet();
      });
    }

    tabs.querySelectorAll("[data-app-bottom-tabs-menu]").forEach((button) => {
      button.addEventListener("click", () => {
        const menuKey = button.getAttribute("data-app-bottom-tabs-menu");
        const headerMenuToggle = document.querySelector(`[data-app-header-menu-toggle='${menuKey}']`);
        if (headerMenuToggle) {
          clearPendingBottomTabsMenu();
          window.scrollTo({ top: 0, behavior: "smooth" });
          pendingBottomTabsMenuTimer = window.setTimeout(() => {
            pendingBottomTabsMenuTimer = null;
            headerMenuToggle.click();
          }, 120);
        }
      });
    });
  });

  document.querySelectorAll("[data-app-search-sheet-close]").forEach((button) => {
    button.addEventListener("click", () => {
      closeSearchSheet();
    });
  });

  if (searchSheet) {
    const copySearchSheetText = (text) => {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      }

      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "fixed";
      textarea.style.top = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      textarea.remove();
      return Promise.resolve();
    };

    const closeSearchSheetShareMenus = () => {
      searchSheet.querySelectorAll(".sunde-share__button[aria-expanded='true']").forEach((button) => {
        button.setAttribute("aria-expanded", "false");
        const menu = button.nextElementSibling;
        if (menu) menu.hidden = true;
      });
    };

    searchSheet.addEventListener("click", (event) => {
      const shareButton = event.target.closest(".sunde-share__button");
      if (shareButton && searchSheet.contains(shareButton)) {
        event.stopPropagation();
        const menu = shareButton.nextElementSibling;
        const isOpen = shareButton.getAttribute("aria-expanded") === "true";
        closeSearchSheetShareMenus();
        shareButton.setAttribute("aria-expanded", String(!isOpen));
        if (menu) menu.hidden = isOpen;
        return;
      }

      const copyButton = event.target.closest("[data-share-action='copy']");
      if (copyButton && searchSheet.contains(copyButton)) {
        event.preventDefault();
        copySearchSheetText(copyButton.dataset.shareUrl || window.location.href).then(() => {
          const label = copyButton.querySelector("[data-share-copy-label]") || copyButton.querySelector("span:last-child");
          if (!label) return;
          label.textContent = "コピーしました";
          setTimeout(() => {
            label.textContent = "リンクをコピー";
            closeSearchSheetShareMenus();
          }, 1200);
        });
        return;
      }

      if (!event.target.closest(".sunde-share")) {
        closeSearchSheetShareMenus();
      }
    });
  }

  const banner = document.querySelector(".js-push-permission-banner");
  if (banner && isStandaloneMode() && shouldShowPushPrompt()) {
    navigator.serviceWorker.getRegistration().then((registration) => {
      if (!registration) {
        banner.style.display = "flex";
        return;
      }
      return registration.pushManager.getSubscription().then((subscription) => {
        if (!subscription) {
          banner.style.display = "flex";
        }
      });
    }).catch(() => {
      banner.style.display = "flex";
    });
  }

  const openButtons = document.querySelectorAll(".js-open-push-permission-modal");
  openButtons.forEach((button) => {
    if (!shouldShowPushPrompt()) {
      button.style.display = "none";
      return;
    }
    button.addEventListener("click", () => {
      openPushPermissionModal();
    });
  });

  const closeButton = document.querySelector(".js-close-push-permission");
  if (closeButton) {
    closeButton.addEventListener("click", () => {
      closePushPermissionModal();
    });
  }

  const enableButton = document.querySelector(".js-enable-push-permission");
  if (enableButton) {
    enableButton.addEventListener("click", () => {
      requestPushPermission();
    });
  }

  const logoutLinks = document.querySelectorAll(".js-logout-link");
  logoutLinks.forEach((link) => {
    link.addEventListener("click", async (event) => {
      event.preventDefault();
      await cleanupPushSubscription();
      submitLogoutForm(link.getAttribute("href"));
    });
  });
});

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
